export default __webpack_public_path__ + "static/habit-haven-cf5fc84783e5a8e148fc000deda0d63d.svg";